import { render, staticRenderFns } from "./movementmenu_govem.vue?vue&type=template&id=a518d566&"
import script from "./movementmenu_govem.vue?vue&type=script&lang=js&"
export * from "./movementmenu_govem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports